import { CommonModule } from '@angular/common';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TourPrimeNgModule } from 'ngx-ui-tour-primeng';
import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';
import { DialogModule } from 'primeng/dialog';
import { InputMaskModule } from 'primeng/inputmask';
import { InputTextModule } from 'primeng/inputtext';
import { KeyFilterModule } from 'primeng/keyfilter';
import { ListboxModule } from 'primeng/listbox';
import { MultiSelectModule } from 'primeng/multiselect';
import { PanelModule } from 'primeng/panel';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SelectModule } from 'primeng/select';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SkeletonModule } from 'primeng/skeleton';
import { TextareaModule } from 'primeng/textarea';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { TooltipModule } from 'primeng/tooltip';

import { ReactiveFormActionsComponent } from './components/form-actions/form-actions.component';
import { ReactiveFormHeaderComponent } from './components/form-header/form-header.component';
import { ReactiveFormSectionsComponent } from './components/form-sections/form-sections.component';
import { ReactiveFormSignatureComponent } from './components/form-signature/form-signature.component';
import { ReactiveFormTableComponent } from './components/form-table/form-table.component';
import { ReactiveDictadoComponent } from './dictado/dictado.component';
import { ReactiveCameraComponent } from './upload-images/camera/camera.component';
import { ReactiveUploadImagesComponent } from './upload-images/upload-images.component';
import { FieldComponent } from './field/field.component';
import { ReactiveCalendarFieldComponent } from './field/components/calendar-field/calendar-field.component';
import { ReactiveFieldLabelComponent } from './field/components/field-label/field-label.component';
import { ReactiveReadOnlyFieldComponent } from './field/components/read-only-field/read-only-field.component';
import { ReactiveSelectFieldComponent } from './field/components/select-field/select-field.component';
import { ReactiveSwitchFieldComponent } from './field/components/switch-field/switch-field.component';
import { ReactiveTextFieldComponent } from './field/components/text-field/text-field.component';
import { ReactiveTextareaFieldComponent } from './field/components/textarea-field/textarea-field.component';
import { RepeatableCellComponent } from './field/repeatable-group/components/repeatable-cell/repeatable-cell.component';
import {
  RepeatableDoseRecommendationComponent,
} from './field/repeatable-group/components/repeatable-dose-recommendation/repeatable-dose-recommendation.component';
import {
  RepeatableGroupToolbarComponent,
} from './field/repeatable-group/components/repeatable-group-toolbar/repeatable-group-toolbar.component';
import {
  RepeatableRowActionsComponent,
} from './field/repeatable-group/components/repeatable-row-actions/repeatable-row-actions.component';
import {
  RepeatableProductInfoDialogComponent,
} from './field/repeatable-group/product-info-dialog/product-info-dialog.component';
import { RepeatableGroupComponent } from './field/repeatable-group/repeatable-group.component';
import { ReactiveFormBuilderComponent } from './form-builder.component';
import { SignatureComponent } from './signature/signature.component';
import { ReactiveRequestButtonComponent } from './request-button/request-button.component';

const REACTIVE_FORM_BUILDER_COMPONENTS = [
  ReactiveFormBuilderComponent,
  ReactiveFormActionsComponent,
  ReactiveFormHeaderComponent,
  ReactiveFormSectionsComponent,
  ReactiveFormSignatureComponent,
  ReactiveFormTableComponent,
  ReactiveDictadoComponent,
  ReactiveCameraComponent,
  ReactiveUploadImagesComponent,
  FieldComponent,
  ReactiveCalendarFieldComponent,
  ReactiveFieldLabelComponent,
  ReactiveReadOnlyFieldComponent,
  ReactiveSelectFieldComponent,
  ReactiveSwitchFieldComponent,
  ReactiveTextFieldComponent,
  ReactiveTextareaFieldComponent,
  RepeatableCellComponent,
  RepeatableDoseRecommendationComponent,
  RepeatableGroupToolbarComponent,
  RepeatableRowActionsComponent,
  RepeatableProductInfoDialogComponent,
  RepeatableGroupComponent,
  ReactiveRequestButtonComponent,
  SignatureComponent,
];

@NgModule({
  declarations: [...REACTIVE_FORM_BUILDER_COMPONENTS],
  exports: [...REACTIVE_FORM_BUILDER_COMPONENTS],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    TourPrimeNgModule,
    ButtonModule,
    DatePickerModule,
    DialogModule,
    InputMaskModule,
    InputTextModule,
    KeyFilterModule,
    ListboxModule,
    MultiSelectModule,
    PanelModule,
    ProgressSpinnerModule,
    SelectModule,
    SelectButtonModule,
    SkeletonModule,
    TextareaModule,
    ToggleSwitchModule,
    TooltipModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ReactiveFormBuilderModule {}
